module.exports = __webpack_public_path__ + "static/culture.value-e7b2aa58a5065664a824a8a9275b5e7a.png";